import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'

import {GroupSMS} from '../modules/SMSBroadCast/GroupSMS'
import {ContactFileSMS} from '../modules/SMSBroadCast/ContactFileSMS'
import {SmartSMS} from '../modules/SMSBroadCast/SmartSMS'
import {QuickSMS} from '../modules/SMSBroadCast/QuickSMS'
import CreateUser from '../modules/Users/CreateUser'
import Price from '../modules/PriceList/Price'
import TodayBroadCast from '../modules/LiveReports/TodayBroadCast'
import TodaySMS from '../modules/LiveReports/TodaySMS'
import SummeryLogs from '../modules/LiveReports/SummeryLogs'
import MNOBalanceNotifyList from '../modules/Monitoring/MNOBalanceNotifyList'
import BalanceNotificationLog from '../modules/Monitoring/BalanceNotificationLog'
import BalanceThreshold from '../modules/Monitoring/BalanceThreshold'
import LogoUpload from '../modules/Settings/LogoUpdates'
import BroadCastHistory from '../modules/Archive/BroadCastHistory'
import SMSHistory from '../modules/Archive/SMSHistory'
import RechargeFrom from '../modules/Billing/TransactionReports/RechargeFrom'
import RechargeTo from '../modules/Billing/TransactionReports/RechargeTo'
import InvoiceCreate from '../modules/Billing/Invoice/InvoiceCreate'
import InvoiceList from '../modules/Billing/Invoice/InvoiceList'
import Send from '../modules/Schedules/Send'
import Pending from '../modules/Schedules/Pending'
import ChangePassword from '../modules/DeveloperOptions/ChangePassword'
import OpwiseReport from '../modules/SummeryReport/OpwiseReport'
import SenderwiseReport from '../modules/SummeryReport/SenderwiseReport'
import OPandSenderwiseReport from '../modules/SummeryReport/OPandSenderwiseReport'
import {SMSCampaign} from '../modules/SMSBroadCast/SMSCampaign'
import {RoleBasedRoute} from './RoleBasedRoute'
import RetrySmsList from '../modules/LiveReports/RetrySmsList'
import {UpdateSenderId} from '../modules/Users/UpdateSenderId'
import Cancel from '../modules/Schedules/Cancel'
import PriceUpdate from '../modules/PriceList/PriceUpdate'
import ApiKey from '../modules/DeveloperOptions/ApiKey'
import Documentation from '../modules/DeveloperOptions/Documentation'
import KycForm from '../modules/Users/KycForm'
import UserDetails from '../modules/Users/UserDetails'
import Payment from '../modules/PaymentRequest/Payment'
import SenderIdWrapper from '../modules/SMSBroadCast/Sender/SenderIdWrapper'
import SMSTemplateWrapper from '../modules/SMSBroadCast/SMSTemplate/SMSTemplateWrapper'
import SpamFiltrerWrapper from '../modules/SpamFilter/SpamFiltrerWrapper'
import UserListWrapper from '../modules/Users/UserListWrapper'
import DeliveryLogReport from '../modules/Archive/DeliveryLogReport'
import SettingWrapper from '../modules/Settings/SettingWrapper'
import TicketOverview from '../modules/Ticket/TicketOverview'
import TIcketsListWrapper from '../modules/Ticket/TIcketList/TicketsListWrapper'
import Department from '../modules/Ticket/Department'
import ArticleWrapper from '../modules/KnowledgeBase/Article/ArticleWrapper'
import CategoryWrapper from '../modules/KnowledgeBase/Category/CategoryWrapper'
import KnowledgeBaseOverview from '../modules/KnowledgeBase/KnowledgeBaseOverview'
import RoutesConfig from '../modules/routes/RoutesConfig'
import RouteManagement from '../modules/route-mangement/RouteManagement'
import DLRManagement from '../modules/dlr-management/DLRManagement'
import TicketQueryDetails from '../modules/Ticket/TIcketList/TicketQueryDetails'
import ArticlesByCategory from '../modules/KnowledgeBase/Article/ArticlesByCategory'
import ArticleDetails from '../modules/KnowledgeBase/Article/ArticleDetails'
import ArticleForm from '../modules/KnowledgeBase/Article/ArticleForm'
import RouteSenderDetails from '../modules/route-mangement/RouteSenderDetails'
import UserRole from '../modules/Users/user-role/UserRole'
import RoleManagement from '../modules/Users/role-management/RoleManagement'
import MenuManagement from '../modules/menu-management/MenuManagement'
import InvoiceView from '../modules/Billing/Invoice/InvoiceView'
import {Forbidden} from '../modules/errors/components/Forbidden'
import ProtectedRoute from './ProtectedRoute'
import PreviewInvoice from '../modules/Billing/Invoice/PreviewInvoice'
import Voucher from '../modules/Billing/Voucher/Voucher'
import VoucherPreview from '../modules/Billing/Voucher/VoucherPreview'
import CustomerLedger from '../modules/customer-ledger/CustomerLedger'

const ContactAndGroup = lazy(() => import('../modules/ContactAndGroup/ContactAndGroup'))

const RoutesRoleWise = () => {
  const Analyze = lazy(() => import('../modules/analyze/Analyze'))
  const RittProfile = lazy(() => import('../modules/ritt-settings/ritt-profile/RittProfile'))
  const AccountSetting = lazy(
    () => import('../modules/ritt-settings/account-settings/AccountSettings')
  )
  const ContactGroup = lazy(
    () => import('../modules/ContactAndGroup/components/contact-group/ContactGroup')
  )
  const ContactList = lazy(
    () => import('../modules/ContactAndGroup/components/contact-list/ContactList')
  )
  const MiddlewarePage = lazy(() => import('../modules/middleware/MiddlewarePage'))
  const PushManagement = lazy(() => import('../modules/push-management/PushManagement'))
  const PaymentPage = lazy(() => import('../modules/payment/PaymentPage'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/analyze/dashboard' />} />

        {/* Pages */}
        <Route element={<ProtectedRoute menu='Dashboard' />}>
          <Route path='dashboard' element={<DashboardWrapper />} />
        </Route>
        {/* Lazy Modules */}

        {/* Start RITT */}
        <Route element={<ProtectedRoute menu='Analyze' />}>
          <Route
            path='analyze/*'
            element={
              <SuspensedView>
                <Analyze />
              </SuspensedView>
            }
          />
        </Route>

        <Route element={<ProtectedRoute menu='Middleware Management' />}>
          <Route
            path='middleware-management/*'
            element={
              <SuspensedView>
                <MiddlewarePage />
              </SuspensedView>
            }
          />
        </Route>

        <Route element={<ProtectedRoute menu='Routes' />}>
          <Route
            path='routes/*'
            element={
              <SuspensedView>
                <RoutesConfig />
              </SuspensedView>
            }
          />
        </Route>

        <Route element={<ProtectedRoute menu='Route Management' />}>
          <Route
            path='route-management/*'
            element={
              <SuspensedView>
                <RouteManagement />
              </SuspensedView>
            }
          />
        </Route>

        <Route
          path='route-management/:roleName/:id'
          element={
            <SuspensedView>
              {/* <RoleDetails /> */}
              <RouteSenderDetails />
            </SuspensedView>
          }
        />

        <Route element={<ProtectedRoute menu='Profile Settings' />}>
          <Route
            path='profile/*'
            element={
              <SuspensedView>
                <RittProfile />
              </SuspensedView>
            }
          />
        </Route>

        {/* Account Setting Component have protected routes inside */}
        <Route
          path='account-settings/*'
          element={
            <SuspensedView>
              <AccountSetting />
            </SuspensedView>
          }
        />

        <Route element={<ProtectedRoute menu='DLR Management' />}>
          <Route
            path='dlr-management/*'
            element={
              <SuspensedView>
                <DLRManagement />
              </SuspensedView>
            }
          />
        </Route>
        {/* End RITT */}

        <Route element={<ProtectedRoute menu='Ticket' />}>
          <Route
            path='ticket/view/:id'
            element={
              <SuspensedView>
                <TicketQueryDetails />
              </SuspensedView>
            }
          />
        </Route>

        <Route element={<ProtectedRoute menu='SMS Broadcast' submenu='Quick SMS' />}>
          <Route
            path='smsbroadcast/quicksms'
            element={
              <SuspensedView>
                <QuickSMS />
              </SuspensedView>
            }
          ></Route>
        </Route>

        <Route element={<ProtectedRoute menu='SMS Broadcast' submenu='Group SMS' />}>
          <Route
            path='smsbroadcast/groupsms/*'
            element={
              <SuspensedView>
                <GroupSMS />
              </SuspensedView>
            }
          ></Route>
        </Route>

        <Route element={<ProtectedRoute menu='SMS Broadcast' submenu='Contact File SMS' />}>
          <Route
            path='smsbroadcast/contactfilesms/*'
            element={
              <SuspensedView>
                <ContactFileSMS />
              </SuspensedView>
            }
          ></Route>
        </Route>

        <Route element={<ProtectedRoute menu='Sender ID' />}>
          <Route
            path='smsbroadcast/senderid/*'
            element={
              <SuspensedView>
                <SenderIdWrapper />
              </SuspensedView>
            }
          ></Route>
        </Route>

        <Route element={<ProtectedRoute menu='SMS Broadcast' submenu='SMS Campaign' />}>
          <Route
            path='smsbroadcast/smscampaign/*'
            element={
              <SuspensedView>
                <SMSCampaign />
              </SuspensedView>
            }
          ></Route>
        </Route>

        <Route element={<ProtectedRoute menu='SMS Broadcast' submenu='Smart SMS' />}>
          <Route
            path='smsbroadcast/smartsms/*'
            element={
              <SuspensedView>
                <SmartSMS />
              </SuspensedView>
            }
          ></Route>
        </Route>

        <Route element={<ProtectedRoute menu='SMS Broadcast' submenu='SMS Template' />}>
          <Route
            path='smsbroadcast/smstemplete/*'
            element={
              <SuspensedView>
                <SMSTemplateWrapper />
              </SuspensedView>
            }
          ></Route>
        </Route>

        <Route element={<ProtectedRoute menu='Contact And Group' />}>
          <Route
            path='contactAndgroup/*'
            element={
              <SuspensedView>
                <ContactAndGroup />
              </SuspensedView>
            }
          ></Route>
        </Route>

        <Route element={<ProtectedRoute menu='Contacts' submenu='Contact Group' />}>
          <Route
            path='contacts/contact-group'
            element={
              <SuspensedView>
                <ContactGroup />
              </SuspensedView>
            }
          ></Route>
        </Route>

        <Route element={<ProtectedRoute menu='Contacts' submenu='Contact List' />}>
          <Route
            path='contacts/contact-list/:groupId?'
            element={
              <SuspensedView>
                <ContactList />
              </SuspensedView>
            }
          ></Route>
        </Route>

        <Route element={<ProtectedRoute menu='Spam Filter' />}>
          <Route
            path='spam-filter/*'
            element={
              <SuspensedView>
                <SpamFiltrerWrapper />
              </SuspensedView>
            }
          />
        </Route>

        <Route element={<ProtectedRoute menu='Users' submenu='User List' />}>
          <Route
            path='users/list/*'
            element={
              <SuspensedView>
                <UserListWrapper />
              </SuspensedView>
            }
          />
        </Route>

        <Route element={<ProtectedRoute menu='Users' />}>
          <Route
            path='users/:useraction/*'
            element={
              <SuspensedView>
                <CreateUser />
              </SuspensedView>
            }
          />
        </Route>

        <Route element={<ProtectedRoute menu='Users' submenu='Role' />}>
          <Route
            path='users/role/*'
            element={
              <SuspensedView>
                <UserRole />
              </SuspensedView>
            }
          ></Route>
        </Route>

        <Route element={<ProtectedRoute menu='Users' submenu='Role Management' />}>
          <Route
            path='users/roles-management/*'
            element={
              <SuspensedView>
                <RoleManagement />
              </SuspensedView>
            }
          ></Route>
        </Route>

        <Route element={<ProtectedRoute menu='Menu Management' />}>
          <Route
            path='menu-management/*'
            element={
              <SuspensedView>
                <MenuManagement />
              </SuspensedView>
            }
          ></Route>
        </Route>

        <Route element={<ProtectedRoute menu='Users' />}>
          <Route
            path='users/kycForm/:id'
            element={
              <SuspensedView>
                <KycForm />
              </SuspensedView>
            }
          />
        </Route>

        <Route element={<ProtectedRoute menu='Users' />}>
          <Route
            path='users/updatesenderid/:id/*'
            element={
              <SuspensedView>
                <UpdateSenderId />
              </SuspensedView>
            }
          />
        </Route>

        <Route element={<ProtectedRoute menu='Users' />}>
          <Route
            path='users/userdetails/:id/*'
            element={
              <SuspensedView>
                <UserDetails />
              </SuspensedView>
            }
          />
        </Route>

        <Route element={<ProtectedRoute menu='Live Reports' submenu='Today Broadcast' />}>
          <Route
            path='livereports/todaybroadcast/*'
            element={
              <SuspensedView>
                <TodayBroadCast />
              </SuspensedView>
            }
          ></Route>
        </Route>

        <Route element={<ProtectedRoute menu='Live Reports' submenu='Today SMS' />}>
          <Route
            path='livereports/todaysms/*'
            element={
              <SuspensedView>
                <TodaySMS />
              </SuspensedView>
            }
          ></Route>
        </Route>

        <Route element={<ProtectedRoute menu='Live Reports' submenu='Summary Logs' />}>
          <Route
            path='livereports/summerylogs/*'
            element={
              <SuspensedView>
                <SummeryLogs />
              </SuspensedView>
            }
          ></Route>
        </Route>

        <Route element={<ProtectedRoute menu='Live Reports' submenu='Retry SMS List' />}>
          <Route
            path='livereports/retrysmslist/*'
            element={
              <SuspensedView>
                <RetrySmsList />
              </SuspensedView>
            }
          ></Route>
        </Route>

        <Route element={<ProtectedRoute menu='Price List' submenu='Price' />}>
          <Route
            path='pricelist/price/*'
            element={
              <SuspensedView>
                <Price />
              </SuspensedView>
            }
          ></Route>
        </Route>

        <Route element={<ProtectedRoute menu='Users' />}>
          <Route
            path='users/list/price-update/:id'
            element={
              <SuspensedView>
                <PriceUpdate />
              </SuspensedView>
            }
          ></Route>
        </Route>

        <Route element={<ProtectedRoute menu='Archive' submenu='Broadcast History' />}>
          <Route
            path='archive/broadcasthistory/*'
            element={
              <SuspensedView>
                <BroadCastHistory />
              </SuspensedView>
            }
          ></Route>
        </Route>

        <Route element={<ProtectedRoute menu='Archive' submenu='Broadcast History' />}>
          <Route
            path='archive/smshistory/*'
            element={
              <SuspensedView>
                <SMSHistory />
              </SuspensedView>
            }
          ></Route>
        </Route>

        <Route element={<ProtectedRoute menu='Archive' submenu='Delivery Log Report' />}>
          <Route
            path='archive/archivedeliverylogreport/*'
            element={
              <SuspensedView>
                <DeliveryLogReport />
              </SuspensedView>
            }
          ></Route>
        </Route>

        <Route element={<ProtectedRoute menu='Billing' submenu='Recharge From' />}>
          <Route
            path='Billing/TransactionReports/rechargefrom/*'
            element={
              <SuspensedView>
                <RechargeFrom />
              </SuspensedView>
            }
          />
        </Route>

        <Route element={<ProtectedRoute menu='Billing' submenu='Recharge To' />}>
          <Route
            path='Billing/TransactionReports/rechargeto/*'
            element={
              <SuspensedView>
                <RechargeTo />
              </SuspensedView>
            }
          />
        </Route>

        <Route element={<ProtectedRoute menu='Billing' submenu='Invoice Create' />}>
          <Route
            path='Billing/Invoice/create/*'
            element={
              <SuspensedView>
                <InvoiceCreate />
              </SuspensedView>
            }
          />
        </Route>

        <Route element={<ProtectedRoute menu='Billing' submenu='Invoice List' />}>
          <Route
            path='Billing/Invoice/list/*'
            element={
              <SuspensedView>
                <InvoiceList />
              </SuspensedView>
            }
          />
        </Route>

        <Route element={<ProtectedRoute menu='Billing' submenu='Invoice List' />}>
          <Route
            path='Billing/Invoice/:id/*'
            element={
              <SuspensedView>
                <InvoiceView />
              </SuspensedView>
            }
          />
        </Route>

        <Route
          path='Billing/Invoice/preview/*'
          element={
            <SuspensedView>
              <PreviewInvoice />
            </SuspensedView>
          }
        />

        <Route element={<ProtectedRoute menu='Billing' submenu='Voucher' />}>
          <Route
            path='Billing/voucher/*'
            element={
              <SuspensedView>
                <Voucher />
              </SuspensedView>
            }
          />
        </Route>

        <Route
          path='Billing/voucher/preview/:id/*'
          element={
            <SuspensedView>
              <VoucherPreview />
            </SuspensedView>
          }
        />

        <Route element={<ProtectedRoute menu='Billing' submenu='Customer Ledger' />}>
          <Route
            path='customer-ledger/*'
            element={
              <SuspensedView>
                <CustomerLedger />
              </SuspensedView>
            }
          />
        </Route>

        <Route element={<ProtectedRoute menu='Schedules' submenu='Send' />}>
          <Route
            path='Schedules/send/*'
            element={
              <SuspensedView>
                <Send />
              </SuspensedView>
            }
          ></Route>
        </Route>

        <Route element={<ProtectedRoute menu='Schedules' submenu='Pending' />}>
          <Route
            path='Schedules/pending/*'
            element={
              <SuspensedView>
                <Pending />
              </SuspensedView>
            }
          ></Route>
        </Route>

        <Route element={<ProtectedRoute menu='Schedules' submenu='Cancel' />}>
          <Route
            path='Schedules/cancel/*'
            element={
              <SuspensedView>
                <Cancel />
              </SuspensedView>
            }
          ></Route>
        </Route>

        <Route element={<ProtectedRoute menu='Summary Report' submenu='OP Wise Report' />}>
          <Route
            path='SummeryReport/opwisereport/*'
            element={
              <SuspensedView>
                <OpwiseReport />
              </SuspensedView>
            }
          ></Route>
        </Route>

        <Route element={<ProtectedRoute menu='Summary Report' submenu='Sender Wise Report' />}>
          <Route
            path='SummeryReport/senderwisereport/*'
            element={
              <SuspensedView>
                <SenderwiseReport />
              </SuspensedView>
            }
          ></Route>
        </Route>

        <Route
          element={<ProtectedRoute menu='Summary Report' submenu='OP And Sender Wise Report' />}
        >
          <Route
            path='SummeryReport/opandSenderwisereport/*'
            element={
              <SuspensedView>
                <OPandSenderwiseReport />
              </SuspensedView>
            }
          ></Route>
        </Route>

        <Route element={<ProtectedRoute menu='Developer Options' submenu='Change Password' />}>
          <Route
            path='DeveloperOptions/changepassword/*'
            element={
              <SuspensedView>
                <ChangePassword />
              </SuspensedView>
            }
          ></Route>
        </Route>

        <Route element={<ProtectedRoute menu='Developer Options' submenu='API Key' />}>
          <Route
            path='DeveloperOptions/apikey/*'
            element={
              <SuspensedView>
                <ApiKey />
              </SuspensedView>
            }
          ></Route>
        </Route>

        <Route element={<ProtectedRoute menu='Developer Options' submenu='Documentation' />}>
          <Route
            path='DeveloperOptions/documentation/*'
            element={
              <SuspensedView>
                <Documentation />
              </SuspensedView>
            }
          ></Route>
        </Route>

        {/* Ticket Start */}
        <Route element={<ProtectedRoute menu='Ticket' submenu='Overview' />}>
          <Route
            path='tickets/overview/*'
            element={
              <SuspensedView>
                <TicketOverview />
              </SuspensedView>
            }
          ></Route>
        </Route>

        <Route element={<ProtectedRoute menu='Ticket' submenu='List' />}>
          <Route
            path='tickets/list/*'
            element={
              <SuspensedView>
                <TIcketsListWrapper />
              </SuspensedView>
            }
          ></Route>
        </Route>

        <Route element={<ProtectedRoute menu='Ticket' submenu='Department' />}>
          <Route
            path='tickets/department/*'
            element={
              <SuspensedView>
                <Department />
              </SuspensedView>
            }
          ></Route>
        </Route>
        {/* Ticket End */}

        {/* Knowledge Base Start */}
        <Route element={<ProtectedRoute menu='Knowledge Base' submenu='Overview' />}>
          <Route
            path='knowledgebase/overview/*'
            element={
              <SuspensedView>
                <KnowledgeBaseOverview />
              </SuspensedView>
            }
          ></Route>
        </Route>

        <Route element={<ProtectedRoute menu='Knowledge Base' submenu='Article' />}>
          <Route
            path='knowledgebase/article/*'
            element={
              <SuspensedView>
                <ArticleWrapper />
              </SuspensedView>
            }
          ></Route>
        </Route>

        <Route element={<ProtectedRoute menu='Knowledge Base' submenu='Article' />}>
          <Route
            path='knowledgebase/article/:type'
            element={
              <SuspensedView>
                <ArticleForm />
              </SuspensedView>
            }
          ></Route>
        </Route>

        <Route element={<ProtectedRoute menu='Knowledge Base' submenu='Category' />}>
          <Route
            path='knowledgebase/category/*'
            element={
              <SuspensedView>
                <CategoryWrapper />
              </SuspensedView>
            }
          ></Route>
        </Route>

        <Route element={<ProtectedRoute menu='Knowledge Base' submenu='Article' />}>
          <Route
            path='knowledgebase/articles-by-category/:id'
            element={
              <SuspensedView>
                <ArticlesByCategory />
              </SuspensedView>
            }
          ></Route>
        </Route>

        <Route element={<ProtectedRoute menu='Knowledge Base' submenu='Article View' />}>
          <Route
            path='knowledgebase/article-view/:id'
            element={
              <SuspensedView>
                <ArticleDetails />
              </SuspensedView>
            }
          ></Route>
        </Route>
        {/* Knowledge Base End */}

        <Route element={<ProtectedRoute menu='Settings' />}>
          <Route
            path='settings/*'
            element={
              <SuspensedView>
                <SettingWrapper />
              </SuspensedView>
            }
          ></Route>
        </Route>

        <Route element={<ProtectedRoute menu='Monitoring' submenu='MNO Balance Notify' />}>
          <Route
            path='Monitoring/mnobalancenotifylist/*'
            element={
              <SuspensedView>
                <MNOBalanceNotifyList />
              </SuspensedView>
            }
          ></Route>
        </Route>

        <Route element={<ProtectedRoute menu='Monitoring' submenu='Balance Threshold' />}>
          <Route
            path='Monitoring/balancethreshold/*'
            element={
              <SuspensedView>
                <BalanceThreshold />
              </SuspensedView>
            }
          ></Route>
        </Route>

        <Route element={<ProtectedRoute menu='Monitoring' submenu='Balance Notification Log' />}>
          <Route
            path='Monitoring/balancenotificationlog/*'
            element={
              <SuspensedView>
                <BalanceNotificationLog />
              </SuspensedView>
            }
          ></Route>
        </Route>

        <Route element={<ProtectedRoute menu='Payment' />}>
          <Route
            path='payment/*'
            element={
              <SuspensedView>
                <PaymentPage />
              </SuspensedView>
            }
          />
        </Route>

        <Route element={<ProtectedRoute menu='Push Management' />}>
          <Route
            path='push-management/*'
            element={
              <SuspensedView>
                <PushManagement />
              </SuspensedView>
            }
          />
        </Route>

        {/* FORBIDDEN ROUTE / UNAUTHORIZE ROUTE WILL NAVIGATE THIS ROUTE */}
        <Route
          path='forbidden'
          element={
            <SuspensedView>
              <Forbidden />
            </SuspensedView>
          }
        />
      </Route>
      {/* End Master Layout */}

      <Route element={<RoleBasedRoute allowedRoles={[1]} />}>
        <Route
          path='Settings/logoupdates/*'
          element={
            <SuspensedView>
              <LogoUpload />
            </SuspensedView>
          }
        ></Route>

        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

export const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {RoutesRoleWise}
